//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/lib/util';
import emptyCell from "../../components/emptyCell";

export default {
    name: "complaintList",
    components: {
        emptyCell,
    },
    data() {
        return {
            memberId: 0,
            list: [],
            refreshing: false,
            pageIndex: 0,
            pageSize: 10,
            loading: false,
            finished: false,
            downloadUrl: util.ApiUrl + '/file/download/',
            show: false,
            delId: 0,
            saving: false,
            member: {}
        }
    },
    methods: {
        onRefresh() {
            this.pageIndex = 1;
            this.getComplaintRecords();
        },
        onLoad() {
            this.pageIndex++;
            this.getComplaintRecords()
        },
        getComplaintRecords() {
            if (this.memberId > 0) {
                this.refreshing = this.pageIndex === 1;
                this.loading = this.pageIndex > 1;
                var page = {
                    memberId: this.memberId,
                    workOrderType: 1,
                    maxResultCount: this.pageSize,
                    // complaintType: 0,
                    skipCount: (this.pageIndex - 1) * this.pageSize
                };
                abp.ajax.post('/api/services/app/WorkOrder/MemberSearchWorkOrders', page).then((res) => {
                    if (this.pageIndex === 1) {
                        this.list = [];
                    }
                    this.list.push(...res.data.result.items);
                    // console.log(this.list);
                    if (res.data.result.items.length < this.pageSize) {
                        this.finished = true;
                    } else {
                        this.finished = false;
                    }
                }).then(() => {
                    this.refreshing = false;
                    this.loading = false;
                }).catch((error) => {
                    this.refreshing = false;
                    this.loading = true;
                }).finally(() => {
                    // this.refreshing = false;
                    // this.loading = true;
                });
            }

        },
        onConfirm() {
            this.onDelete();
        },
        onShowDialog(id) {
            this.delId = 0;
            this.delId = id;
            this.show = true;

        },
        onDelete() {
        },
        onCancelComplaint(id) {
            var page = {
                id: 0,
                complaintRecordId: id,
                operatorType: 6,
                dealWithRemark: '业主微信服务号取消',
                file: {associateType: 'ComplaintInfoFile'}
            };
            this.saving = true;
            // abp.ajax.post('/api/services/app/ComplaintRecord/SaveComplaintChuLi', page).then((res) => {
            //     this.$toast('取消成功');
            //     this.onRefresh();
            // }).finally(() => {
            //     this.saving = false;
            // });
        },
        showRecordInfo(id) {
            this.$router.push({
                name: 'complaintRecordInfo',
                params: {
                    id: id
                }
            })
        },
        getMyMember() {
            const vm = this;
            this.$store.dispatch({
                type: 'member/getMyMember'
            }).then(() => {
                vm.member = vm.$store.state.member.memberInfo;
                vm.memberId = vm.member.id;
                localStorage.setItem('MemberId', vm.member.id);

                vm.onRefresh();

            }).finally(() => {
                vm.$toast.clear();
            });
        }
    },
    created() {
        this.getMyMember()
        // this.memberId = parseInt(this.$route.params.id) || 0;
        // if (this.memberId > 0) {
        //     this.onRefresh();
        // }
    }
}
